import React, { JSX, ReactElement } from 'react'
import { Box, Popover, Theme } from '@mui/material'

import { makeStyles } from '@mui/styles'

interface IPopOverComponentProps {
  popOverChild: ReactElement<any, any>
  popOverContent: JSX.Element
}

const useStyles = makeStyles((theme: Theme) => ({
  popover: {
    pointerEvents: 'none',
  },
  paper: {
    padding: '10px',
  },
}))

const PopOverComponent: React.FC<IPopOverComponentProps> = (props) => {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = React.useState(null)

  const handlePopoverOpen = (event: any) => {
    setAnchorEl(event.currentTarget)
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  return (
    <>
      <Box
        component='div'
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      >
        {props.popOverChild}
      </Box>
      <Popover
        className={classes.popover}
        classes={{
          paper: classes.paper,
        }}
        elevation={4}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        {props.popOverContent}
      </Popover>
    </>
  )
}
export default PopOverComponent
